<script>

import config from '../../common/genericPanelConf';
import Service from '../../services/stock-management';
import CommonService from '../../services/common';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import {FilterMatchMode} from 'primevue/api';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable, ResponsiveButton
    },
    data(){
        return{
            configuration: {},
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(),-1),
            },
            twentyFour: '24.00',
        }
    },
    created(){
        this.configuration = config.getConfiguration('StockManagementManualEditLog');
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        load(){
            let filters = [];

            filters.push({
                operator: 'eq',
                value: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
                property: 'ReferenceDate',
                propName: 'referenceDate'
            });
            this.$refs.manualEditLogGrid.filterFromView(filters);
        }
    },
    computed: {
        conf(){
            return config;
        },
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    }
}
</script>



<template>
    <div class="grid">
        <div class="col-8 lg:col-2 field">
            <label for="referenceDate">{{$t('StockManagementDailyTank.referenceDate')}}</label>
            <Calendar
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-2 lg:col-1 field">
            <label>{{$t('at')}}</label>
            <InputText readOnly v-model="twentyFour" class="w-full " />
        </div>
        <div class="col-12 lg:col-7">
                <div class="p-3">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="load"/>   
                </div>
            </div>
        <div class="col-12" style="height: calc(100vh - 210px)">
            <GenericDataTable ref="manualEditLogGrid" :configuration="configuration" :category="category" :name="name" />
        </div>
    </div>
</template>